import { useMemo } from 'react';
import type { MetricasUsuario } from '@/lib/usuarioExport';
import type { Periodo } from '@/lib/periodoFiltro';
import type { DiasTrabalhadosResposta } from '@/services/api';
import { ResumoDiasTrabalhados, SinalFiltro, resumirDiasTrabalhados } from '@/lib/diasTrabalhados';

/** Resumo de dias trabalhados por usuário (id → resumo) para o sinal escolhido. */
export function useResumoDias(
  metricas: MetricasUsuario[],
  diasTrabalhados: DiasTrabalhadosResposta | null,
  periodo: Periodo,
  sinal: SinalFiltro,
) {
  return useMemo(() => {
    const mapa = new Map<string, ResumoDiasTrabalhados>();
    if (!diasTrabalhados) return mapa;
    for (const m of metricas) {
      mapa.set(m.id, resumirDiasTrabalhados(diasTrabalhados.usuarios[m.id], diasTrabalhados.hoje, periodo, sinal));
    }
    return mapa;
  }, [diasTrabalhados, metricas, periodo, sinal]);
}
